import { API, graphqlOperation } from "aws-amplify";
import handleError from "../../errorHandler";
import { GET_ACTIVITY_SUMMARY, GET_ACTIVITY_SUMMARY_SUCCESS, GET_ACTIVITY_SUMMARY_FAILURE, TRIGGER_TOAST } from "../constants";
import { GetActivitySummaryReport } from "./../../queries";

const getActivityReport = (edgeUserID: number, companyID: number, period: any, date: string) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_ACTIVITY_SUMMARY });
    if (!!sessionStorage.getItem("isDemoUser")) {
      const dummyData = require("../../data/MockData/getActivitySummary.json");
      dispatch({ type: GET_ACTIVITY_SUMMARY_SUCCESS, payload: { ...dummyData } });
    }
    else {
      const activityReportHandle = API.graphql(graphqlOperation(GetActivitySummaryReport(edgeUserID.toString(), 1, "activitySummary", companyID.toString(), `{'period':'${period}','StartDate': '${date}'}`))) as Promise<any>;
      // const activityReportHandle = API.graphql(graphqlOperation(GetActivitySummaryReport("492834", 1, "activitySummary", "14", `{'period':'6','StartDate':'09/09/2020'}`))) as Promise<any>;
      activityReportHandle.then(async (activityReportData: any) => {
        let response = JSON.parse(activityReportData.data.getProgressDetails);
        if (response && response.data) {
          dispatch({ type: GET_ACTIVITY_SUMMARY_SUCCESS, payload: { ...response } });
        } else {
          dispatch({ type: GET_ACTIVITY_SUMMARY_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: 'error',
              transMessage: "message_errorDefault"
            },
          });
        }
      })
      .catch((err: any) => {
        // handleError(err);
        dispatch({ type: GET_ACTIVITY_SUMMARY_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity: 'error',
            transMessage: "message_errorDefault"
          },
        });
      });
    }
  };
};

export default {
  getActivityReport,
};
